export const RELEASE_NOTES_ROUTES = {
  RELEASE_NOTES: {
    NAME: "releaseNotes",
    PATH: "/release-notes"
  }
};
